import React from "react";
import styled from "@emotion/styled";
import { useField } from "formik";
import ReactSelect from "react-select";
import FieldContainer from './Misc/FieldContainer';
import getLangData from "../../utils/getLangData";

const Select = (props) => {
  const { label, name, options, inArray, isMulti, disabled } = props;
  const [field, meta, helpers, ] = useField(name);
  const { value } = field;
  const { setValue } = helpers;
  const {error} = meta

  const selected =
    inArray && value
      ? options.filter((option) => option.value[0] === value[0])
      : options.filter((option) => option.value === value);

  return (
    <div className='form-group'>
      <label
      //  className='col-lg-3 col-form-label'
        htmlFor={name}>
        {label} :
      </label>
      <FieldContainer errorMessage={error} className=''>
        <ReactSelect
        // className='custom-select form-control'
        // classNamePrefix=""
          isDisabled={disabled}
          isMulti={isMulti}
          /* {...field} */
          /* {...props} */
          styles={{
            menu: (provided, state) => ({
              // ...provided,
              zIndex: 999,
            }),
          }}
          options={options}
          onChange={(value) => {
            if (isMulti && value === null) {
              setValue([]);
              return;
            }

            if (isMulti) {
              setValue(value);
            } else {
              setValue(value.value);
            }
          }}
          value={selected}
          placeholder={getLangData().search.title}
          /*       {...field}
          {...props} */
        />
      </FieldContainer>
    </div>
  );
};

// const FieldContainer = styled.div`
//   position: relative;
//   padding-bottom: "15px";
//   width: 100%
// `;

export default Select;
